// extracted by mini-css-extract-plugin
export var blackText = "style-module--blackText--628fd";
export var lineThrough = "style-module--lineThrough--ea551";
export var oekoIcon = "style-module--oekoIcon--d0a5d";
export var reduction = "style-module--reduction--7195d";
export var reductionValue = "style-module--reductionValue--57491";
export var totalAmount = "style-module--totalAmount--b9f38";
export var totalAmountValue = "style-module--totalAmountValue--b5792";
export var totalPrice = "style-module--totalPrice--c5958";